import React, { useState } from 'react';

const BoostUpsellModal = ({ isOpen, onClose, onSelectBoost, listingId }) => {
  const [selectedPlan, setSelectedPlan] = useState('pro');

  const boostPlans = [
    {
      id: 'basic',
      title: 'BASIC',
      price: 3990,
      duration: '7 nap',
      features: [
        '+50% gyorsabb eladás',
        'Lista elején megjelenés',
        'Alap kiemelés'
      ],
      color: 'from-gray-500 to-gray-600',
      recommended: false,
      result: '+50% több megtekintés'
    },
    {
      id: 'pro',
      title: 'PRO',
      price: 7990,
      duration: '7 nap',
      features: [
        '+150% gyorsabb eladás',
        'Top lista pozíció',
        'Kiemelt badge',
        '3x több érdeklődő'
      ],
      color: 'from-orange-500 to-red-600',
      recommended: true,
      result: '3x több érdeklődő'
    },
    {
      id: 'ultra',
      title: 'ULTRA',
      price: 14990,
      duration: '7 nap',
      features: [
        '+300% gyorsabb eladás',
        'Első oldal garantált',
        'Premium badge',
        'Ajánlott blokkban',
        'Max láthatóság'
      ],
      color: 'from-purple-500 to-pink-600',
      recommended: false,
      result: 'Garantált első oldal'
    }
  ];

  const handleActivate = () => {
    const plan = boostPlans.find(p => p.id === selectedPlan);
    onSelectBoost(plan);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border-2 border-white/[0.08] shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-[#e31937] to-red-600 p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2">
                🔥 +35% gyorsabb eladás
              </h2>
              <p className="text-white/90">
                A kiemelt hirdetések átlagosan 3x több érdeklődőt hoznak
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Plans */}
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            {boostPlans.map((plan) => (
              <div
                key={plan.id}
                onClick={() => setSelectedPlan(plan.id)}
                className={`relative cursor-pointer rounded-2xl p-6 border-2 transition-all duration-300 ${
                  selectedPlan === plan.id
                    ? 'border-white scale-105 shadow-2xl'
                    : 'border-white/[0.08] hover:border-white/40'
                } ${plan.recommended ? 'ring-4 ring-yellow-400/50' : ''}`}
              >
                {/* Recommended Badge */}
                {plan.recommended && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-yellow-400 to-amber-500 text-black text-xs font-black px-4 py-1 rounded-full shadow-lg">
                    AJÁNLOTT
                  </div>
                )}

                {/* Radio Button */}
                <div className="absolute top-4 right-4">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                    selectedPlan === plan.id ? 'border-white bg-white' : 'border-white/40'
                  }`}>
                    {selectedPlan === plan.id && (
                      <div className="w-3 h-3 rounded-full bg-[#e31937]" />
                    )}
                  </div>
                </div>

                {/* Plan Content */}
                <div className="text-center mb-4">
                  <div className={`inline-block bg-gradient-to-r ${plan.color} text-white font-black text-sm px-4 py-1 rounded-full mb-3`}>
                    {plan.title}
                  </div>
                  <div className="text-4xl font-black text-white mb-1">
                    {plan.price.toLocaleString()} Ft
                  </div>
                  <div className="text-gray-400 text-sm">
                    {plan.duration}
                  </div>
                </div>

                {/* Features */}
                <ul className="space-y-2">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-center gap-2 text-sm text-gray-300">
                      <span className="text-green-500">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Info Box */}
          <div className="bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-xl rounded-xl p-4 border border-blue-500/30 mb-6">
            <div className="flex items-start gap-3">
              <span className="text-2xl">💡</span>
              <div>
                <h4 className="text-white font-bold mb-1">⚠️ Boost nélkül -35% érdeklődés</h4>
                <p className="text-gray-300 text-sm">
                  A nem kiemelt hirdetések <strong className="text-white">60%-kal lassabban</strong> kelnek el és 
                  <strong className="text-white">3x kevesebb érdeklődőt</strong> érnek el.
                </p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-4 rounded-xl transition-colors border-2 border-white/[0.08]"
            >
              Maradok az alap verziónál
            </button>
            <button
              onClick={handleActivate}
              className="flex-1 bg-gradient-to-r from-[#e31937] to-red-600 hover:from-red-600 hover:to-[#e31937] text-white font-black py-4 rounded-xl shadow-xl hover:shadow-2xl hover:shadow-red-500/50 transition-all"
            >
              Aktiválom most! 🚀
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoostUpsellModal;
